import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lightbulb } from 'lucide-react';

interface RoadmapTabProps {
  className?: string;
}

const RoadmapTab: React.FC<RoadmapTabProps> = ({ className = '' }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/roadmap");
  };

  return (
    <div className={`fixed md:bottom-40 bottom-[80px] right-0 z-50 flex ${className}`}>
      <button
        onClick={handleClick}
        className="bg-haus-dark-brown text-white rounded-l-md hover:bg-haus-light-olive transition-colors flex flex-col items-center justify-center md:py-6 md:px-3 p-3"
        aria-label="View product roadmap"
      >
        <div className="hidden md:block vertical-text">
          <span className="tracking-wider">ROADMAP</span>
        </div>
        <div className="md:hidden flex items-center justify-center">
          <Lightbulb size={24} />
        </div>
      </button>
    </div>
  );
};

export default RoadmapTab; 